import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { mobileAppVersionConfigs } from 'src/coach-login/graphql/coachLogin.mutation';
export const detectPlatform = () => {
  const userAgent = navigator.userAgent || '';

  if (/Android/i.test(userAgent)) {
    return 'Android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'iOS';
  } else {
    return 'Unknown';
  }
};
const useMobileAppVersionConfigs = () => {
  const { data, error, loading, ...rest } = useQuery(mobileAppVersionConfigs, {
    fetchPolicy: 'network-only',
  });

  const platform = detectPlatform();

  const appVersion = useMemo(() => {
    if (!data) return '';

    const configKey =
      platform === 'Android'
        ? 'ANDROID_MOBILE_APP_VERSION_NUMBER'
        : platform === 'iOS'
          ? 'IOS_MOBILE_APP_VERSION_NUMBER'
          : '';

    return (
      data.mobileAppVersionNumbers?.find((config) => config.key === configKey)
        ?.value || ''
    );
  }, [data, platform]);

  if (error) {
    console.error('Error fetching mobile app version configs:', error);
  }

  return {
    latestVersionNumber: appVersion,
    platform,
    loading,
    error,
    ...rest,
  };
};

export default useMobileAppVersionConfigs;
